/* OIDC default Redirect URIs constant*/
import {EMAIL, FIRST_NAME, LAST_NAME, USER_DISPLAY_NAME, USER_PRINCIPAL_NAME} from "./samlConstants";

export const DEFAULT_REDIRECT_URIS = [
  {
    "redirectUri": "",
    "redirectUriType": 0
  }
]
/* default OIDC scope constant*/
export const DEFAULT_SCOPE = [
  {
    "scopeName": "profile",
    "isDefault": true,
    "oidcCustomClaims": [
      {
        "oidcCustomClaimName": "name",
        "idpUserAttributeEnum": USER_DISPLAY_NAME,
        "oidcCustomClaimValue": "",
        "addClaimToIdToken": true,
        "addClaimToAccessToken": false
      },
      {
        "oidcCustomClaimName": "given_name",
        "idpUserAttributeEnum": FIRST_NAME,
        "oidcCustomClaimValue": "",
        "addClaimToIdToken": true,
        "addClaimToAccessToken": false
      },
      {
        "oidcCustomClaimName": "family_name",
        "idpUserAttributeEnum": LAST_NAME,
        "oidcCustomClaimValue": "",
        "addClaimToIdToken": true,
        "addClaimToAccessToken": false
      },
      {
        "oidcCustomClaimName": "upn",
        "idpUserAttributeEnum": USER_PRINCIPAL_NAME,
        "oidcCustomClaimValue": "",
        "addClaimToIdToken": true,
        "addClaimToAccessToken": false
      }
    ]
  },
  {
    "scopeName": "email",
    "isDefault": true,
    "oidcCustomClaims": [
      {
        "oidcCustomClaimName": "email",
        "idpUserAttributeEnum": EMAIL,
        "oidcCustomClaimValue": "",
        "addClaimToIdToken": true,
        "addClaimToAccessToken": false
      }
    ]
  }
];

export const NEW_OIDC_CLAIM = {
  "oidcCustomClaimName": "",
  "idpUserAttributeEnum": USER_DISPLAY_NAME,
  "oidcCustomClaimValue": "",
  "addClaimToIdToken": true,
  "addClaimToAccessToken": false
}

export const NEW_OIDC_SCOPE = {
  "scopeName": "",
  "oidcCustomClaims": [
    {
      "oidcCustomClaimName": "",
      "idpUserAttributeEnum": USER_DISPLAY_NAME,
      "oidcCustomClaimValue": "",
      "addClaimToIdToken": true,
      "addClaimToAccessToken": false
    }
  ]
}



// WEBPACK FOOTER //
// ./src/constants/oidcConstants.js